module.exports = __webpack_public_path__ + "media/images/space-d603640b054761daf71f6b8d2221a16d.png";